export const SET_CONTACTS = (state, payload) => {
  state.contacts = payload;
};

export const RESET_CONTACTS = state => {
  state.contacts = [];
};
